import type { CarouselSlide } from './homepage-types';

export type SlideIssue = { slideId: string; field: string; message: string };

export function validateSlides(slides: CarouselSlide[]): SlideIssue[] {
  const issues: SlideIssue[] = [];
  for (const slide of slides) {
    const add = (field: string, message: string) => issues.push({ slideId: slide.id, field, message });
    if (!slide.title.trim()) add('title', 'Укажите название и alt обложки.');
    if (!slide.mediaId) add('mediaId', 'Выберите или загрузите обложку для компьютера.');
    if (!Number.isInteger(slide.durationSeconds) || slide.durationSeconds < 3 || slide.durationSeconds > 120)
      add('durationSeconds', 'Укажите целое число от 3 до 120 секунд.');
    const url = slide.url.trim();
    if (!url && slide.cta.enabled) add('url', 'Укажите URL для CTA-кнопки.');
    if (url) {
      let valid = !/[\s\u0000-\u0020\u007f\\]/u.test(url);
      if (!url.startsWith('/') || url.startsWith('//')) {
        try {
          const parsed = new URL(url);
          valid = valid && parsed.protocol === 'https:' && !!parsed.hostname && !parsed.username && !parsed.password;
        } catch { valid = false; }
      }
      if (!valid) add('url', 'Укажите HTTPS-ссылку (https://…) или внутренний путь (/…). HTTP не поддерживается.');
    }
    if (slide.cta.enabled && !slide.cta.text.trim()) add('cta.text', 'Укажите текст CTA-кнопки.');
  }
  return issues;
}
